import React, {useState} from 'react'
import {Menu, MenuItem} from "@mui/material";
import {useStores} from "../Hooks";
import ConditionalComponent from "../Components/Shared/ConditionalComponent";

export const withRightClick = (WrappedComponent) => {
    return (props) => {
        const [mouseX, setMouseX] = useState(null);
        const [mouseY, setMouseY] = useState(null);
        const [menuActions, setMenuActions] = useState({});
        const {generalStore} = useStores();

        function renderMenuItems() {
            const menuItem = [];
            for (const key in menuActions) {
                if (!menuActions.hasOwnProperty(key)) {
                    continue;
                }
                const menuProps = menuActions[key];
                const callback = menuProps?.callback || null;
                const classStr = menuProps?.classStr || '';
                let MenuIcon = menuProps?.MenuIcon || '';
                menuItem.push(
                    <MenuItem
                        disabled={!callback}
                        className={`dropdown-item${classStr}`}
                        key={key}
                        onClick={(event) => {
                            event.stopPropagation();
                            if (!!callback) {
                                callback(event)
                            }
                        }}
                    >
                        <ConditionalComponent if={!!MenuIcon}>
                            <MenuIcon/>
                        </ConditionalComponent> {generalStore.translate(key)}
                    </MenuItem>
                )
            }
            return menuItem;
        }

        function closeContextMenu(event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            setMouseX(null);
            setMouseY(null);
            setMenuActions({});
        }

        function onRightClick(event, menuFunctions) {
            event.preventDefault();
            event.stopPropagation();

            setMouseX(event.clientX - 2);
            setMouseY(event.clientY - 4);
            setMenuActions(menuFunctions);
        }

        function renderContextMenu() {
            return (
                <Menu
                    keepMounted
                    open={mouseY !== null}
                    onClose={closeContextMenu}
                    anchorReference="anchorPosition"
                    anchorPosition={
                        mouseY !== null && mouseX !== null
                            ? {top: mouseY, left: mouseX}
                            : undefined
                    }
                    onContextMenu={closeContextMenu}
                >
                    {renderMenuItems()}
                </Menu>
            )
        }

        return (
            <>
                <WrappedComponent onRightClick={onRightClick} closeContextMenu={closeContextMenu}  {...props} />
                {renderContextMenu()}
            </>
        );
    }
}
